module.exports = __webpack_public_path__ + "img/Banner Equipamiento.00a7e11f.jpg";